
import { useToast } from '@/hooks/use-toast';
import { AssessmentValidationResult } from './types';

// Helper function to format slug to be URL-friendly
export const formatSlugString = (value: string): string => {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

// Hook for handling assessment validation
export function useAssessmentValidation(
  title: string,
  slug: string,
  toast: ReturnType<typeof useToast>['toast']
): { validateAssessment: () => boolean } {
  const validateAssessment = (): boolean => {
    if (!title.trim()) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Title is required"
      });
      return false;
    }

    if (!slug.trim()) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Slug is required"
      });
      return false;
    }

    return true;
  };

  return { validateAssessment };
}
